<i class="fa fa-exclamation-circle" style="margin-left: 50px;" popover="a"> </i>
<i class="fa fa-exclamation-circle" style="margin-left: 50px;" popover="b"> </i>
<i class="fa fa-exclamation-circle" style="margin-left: 50px;" popover="c"> </i>
<i class="fa fa-exclamation-circle" style="margin-left: 50px;" popover="e"> </i>

<br />
<br />
<br />
<button
  type="button"
  (click)="allOpen()"
  class="btn btn-sm btn-outline-primary"
>
  all open
</button>

<button
  type="button"
  (click)="allHide()"
  class="btn btn-sm btn-outline-primary"
>
  all hide
</button>
